import slick from '@accessible360/accessible-slick';
import $ from 'jQuery';

export default function () {
	$(function() {
		carousel_homepage_init();
		carousel_homepage_cta_aligned_left();
		carousel_homepage_check_sibling_cta_aligned_left();
	});

	$(window).on('resize', function(){
		carousel_homepage_cta_aligned_left();
	});

	const slickDefaults = {
		adaptiveHeight: false,
	};

	class Slider {
		/**
		 * Slider Constructor
		 * @param {HTML Element} element Element to transform into a slick slider.
		 * @param {object} options Optional settings to overwrite the defaults.
		 */
		constructor(element, options) {
			// Grabs reference to the passed in element.
			this.element = element;

			// We can pass in alternate options to overwrite the defaults.
			this.settings = { ...slickDefaults, ...options };

			// Sets a slider variable from the returned slick slider instance built.
			this.slider = this.build();

			// Calls a utility ready function when everything is done.
			this.ready();
		}

		/**
		 * Builds out a slick slider from the element and the settings.
		 * @returns jQuery Element
		 */
		build() {
			return $(this.element).slick(this.settings);
		}

		/**
		 * Utility function to add a ready class to the element.
		 */
		ready() {
			this.element.classList.add('ready');
		}
	}

	function carousel_homepage_init() {
		const $carouselHomepage = $('.block--carousel-homepage');

		if ($carouselHomepage.length) {
			$('.carousel-homepage--images-slider', $carouselHomepage).each(function() {
				const $thisSlider = $(this);
				const $pagination = $thisSlider.parents('.block--carousel-homepage').find('.carousel-homepage--pagination');
				let el = $thisSlider[0];

				const slickSettings = {
					slidesToShow: 1,
					slidesToScroll: 1,
					// arrows: false,
					// infinite: false,
					draggable: false,
					dots: true,
					appendDots: $pagination,
					dotsClass: 'slick--pagination', // Slick generates a <ul.carousel-pagination> within the appendDots container
					customPaging: function (slider, i) {
						const slideNumber = (i + 1);
						const totalSlides = slider.slideCount;
						return '<button class="pagination-control"><img src="' + $('.carousel-homepage--pagination-image').eq(i).attr('src') + '"/><span class="visually-hidden">View slide ' + slideNumber + ' of ' + totalSlides + '</span></button>';
					},
					asNavFor: '.carousel-homepage--text-slider',
				};

				if (!el.Slider) {
					el.Slider = new Slider(el, slickSettings);
				}
			});

			$('.carousel-homepage--text-slider', $carouselHomepage).each(function() {
				const $thisSlider = $(this);
				let el = $thisSlider[0];

				const slickSettings = {
					slidesToShow: 1,
					slidesToScroll: 1,
					dots: false,
					arrows: false,
					draggable: false,
					fade: true,
					asNavFor: '.carousel-homepage--images-slider',
				};

				if (!el.Slider) {
					el.Slider = new Slider(el, slickSettings);
				}
			});
		}
	}

	function carousel_homepage_cta_aligned_left() {
		setTimeout(function() {
			$('.carousel-homepage-combo--bg').each(function() {
				var height = $('.carousel-homepage-combo').height();
				$(this).css('height', height - $('.block--carousel-homepage + .block--cta-aligned-left').height()/2 );
			});
		}, 400);
	}

	function carousel_homepage_check_sibling_cta_aligned_left() {
		setTimeout(function() {
			let carousel = $('.carousel-homepage-combo');
			if ( carousel.next('.block--cta-aligned-left').length ) {
				carousel.addClass('has-cta-aligned-left-sibling');
			}
		});
	}
}
